"use client";

import React from "react";
import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "GEEN PAPIERWERK",
  description: "Wij regelen alle administratie, vergunningen en facturatie. Jij focust je volledig op de installatie van de systemen."
}, {
  title: "VOLLE AGENDA",
  description: "Altijd verzekerd van werk in jouw regio. Wij zorgen voor een constante stroom aan kwalitatieve projecten."
}, {
  title: "SNELLE BETALING",
  description: "Geen lange betaaltermijnen. Wij garanderen een snelle en transparante uitbetaling van al jouw afgeronde klussen."
}, {
  title: "A-MERK KWALITEIT",
  description: "Werk uitsluitend met de beste materialen op de markt. Wij leverende goederen op woensdag voor de volgende week gebaseerd op je agenda in jouw loods of kan bij ons in de loods worden opgehaald"
}];
export default function WarumWartmann() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222467" id="waarom-installateurs-voor-ons-kiezen" className="bg-background py-32 relative">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div ref={sectionRef} className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-12 items-center">
          
          {}
          <div className={`lg:col-span-7 relative -mt-16 lg:-mt-32 z-10 transition-all duration-1000 ease-out transform ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="relative rounded-lg overflow-hidden shadow-2xl bg-muted border border-border/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642666/img/solarix_installer_tablet.png" alt="Solarix installateur controleert projectdetails op een tablet" className="w-full h-auto object-cover aspect-[4/3] lg:aspect-[3/4] object-center" />
              {}
              <div className="absolute inset-0 bg-secondary/10 mix-blend-multiply pointer-events-none"></div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col gap-12 lg:pl-8">
            <div className={`transition-all duration-700 ease-out transform ${isVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`}>
              <h2 className="text-3xl md:text-4xl font-extrabold font-default text-foreground mb-4 tracking-tight">
                Waarom installateurs voor ons kiezen
              </h2>
              <p className="text-muted-foreground text-lg font-default">CL installaties neemt de randzaken uit handen. Wij zorgen voor de klussen, jij zorgt voor de duurzame impact.</p>
            </div>

            <div className="flex flex-col gap-8">
              {benefits.map((benefit, i) => <div key={i} data-index={i} className={`flex gap-5 items-start transition-all duration-700 ease-out transform hover:translate-x-2 transition-transform duration-300 ${isVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`} style={{
              transitionDelay: `${(i + 1) * 150}ms`
            }}>
                  <div className="bg-primary/10 p-2 rounded-full shrink-0 mt-0.5 shadow-sm">
                    <Check className="size-5 text-primary stroke-[3]" />
                  </div>
                  <div>
                    <h3 className="text-sm font-bold uppercase tracking-widest text-foreground font-default mb-1.5">
                      {benefit.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed font-default">
                      {benefit.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}